
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";

export const useOpportunityActions = () => {
  const { toast } = useToast();

  // Fix the handleDelete function
  const handleDelete = async (id: string, userId: string | undefined) => {
    try {
      // First check if the user is the owner of the opportunity or has admin role
      const { data: adminRoles } = await supabase
        .from("user_roles")
        .select("*")
        .eq("user_id", userId)
        .eq("role", "admin");
        
      const isAdmin = adminRoles && adminRoles.length > 0;
      
      const { data: opportunity } = await supabase
        .from("opportunities")
        .select("user_id")
        .eq("id", id);
      
      // Only allow delete if user is admin or the creator of the opportunity
      if (!(isAdmin || (opportunity && opportunity.length > 0 && opportunity[0].user_id === userId))) {
        throw new Error("You don't have permission to delete this opportunity");
      }

      const result = await supabase
        .from("opportunities")
        .delete()
        .eq("id", id);

      if (result.error) throw result.error;

      toast({
        title: "Opportunity deleted",
        description: "The opportunity has been successfully deleted",
      });
      
      return true;
    } catch (error: any) {
      console.error("Error deleting opportunity:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to delete opportunity. Please try again.",
      });
      return false;
    }
  };

  return { handleDelete };
};
